export default __webpack_public_path__ + "static/media/Celonis.0ada297c.png";